import { VXETable } from 'vxe-table'
// import SignObject from '../../public/utils/signJpg'
import XEUtils from 'xe-utils'
import { ykDateFormat, AmountLtoU } from '../../public/utils/globalFunc'
import http from '../../axios/index'
import { convertSign } from '../../public/utils/getSign'
import { Message } from 'element-ui'

// 打印
export const handlePrint = async row => {
  const { data: res } = await http.get('/finance/users')
  if (!res.isSuccess) {
    Message.error(res.errorMessage)
    return false
  }

  const SignObject = convertSign(res.data)

  let lingdaoSign = ''

  let lingongSign = ''

  let signHtml = ``

  if (row.manager_review && row.document_status > 0) {
    lingongSign = `<img src="${SignObject['林源晟']}" />`
  }

  if (row.document_status > 2) {
    lingdaoSign = `<img src="${SignObject['姚杨']}" />`
  }

  if (row.manager_review) {
    signHtml = `
          <tr>
            <td class="tdLabel">单位主管</td>
            <td>
              <div class="signItems">
                ${lingongSign}
              </div>
            </td>
            <td class="tdLabel">汇出公司</td>
            <td colspan="3">${row.remittance_company}</td>
          </tr>

          <tr>
            <td class="tdLabel">领导审批</td>
            <td>
              <div class="signItems">
                ${lingdaoSign}
              </div>
            </td>
            <td class="tdLabel">汇出日期</td>
            <td colspan="3">${ykDateFormat('yyyy-MM-dd', row.remittance_date)}</td>
          </tr>
        `
  } else {
    signHtml = `
          <tr>
            <td rowspan="2" class="tdLabel">领导审批</td>
            <td rowspan="2">
              <div class="signItems">
                ${lingdaoSign}
              </div>
            </td>
            <td class="tdLabel">汇出公司</td>
            <td colspan="3">${row.remittance_company}</td>
          </tr>

          <tr>
            <td class="tdLabel">汇出日期</td>
            <td colspan="3">${ykDateFormat('yyyy-MM-dd', row.remittance_date)}</td>
          </tr>
        `
  }

  const htmlStr = `
          <div class="printContainer">
            <div class="titleContainer">
              <h1 class="mainTitle">汇款申请单</h1>
            </div>

            <table class="mainTable" border="1" cellspacing="0" cellpadding="0">
              <tr>
                <td style="width: 120px;" class="tdLabel">申请日期</td>
                <td>${ykDateFormat('yyyy-MM-dd', row.apply_date)}</td>
                <td style="width: 120px;" class="tdLabel">申请人</td>
                <td colspan="3">${row.users_name}</td>
              </tr>
              <tr>
                <td class="tdLabel">收款人名称</td>
                <td colspan="5">${row.payee}</td>
              </tr>

              <tr>
                <td class="tdLabel">开户行及账号</td>
                <td colspan="5">${row.bank_account}</td>
              </tr>

              <tr>
                <td class="tdLabel">金额(大写)</td>
                <td colspan="3">${AmountLtoU(row['amout'])}</td>
                <td colspan="2">￥:&emsp;${XEUtils.commafy(row.amout, { digits: 2 })}</td>
              </tr>

              <tr>
                <td class="tdLabel">汇款事由</td>
                <td colspan="5">${row.subject_matter}</td>
              </tr>

              ${signHtml}

              <tr>
                <td class="tdLabel">备注</td>
                <td colspan="5">${row.memo}</td>
              </tr>

            </table>

          </div>
      `

  const htmlCss = `
          html,
          body {
            width: 100vw;
            height: 100vh;
            margin: 0 !important;
            padding: 0 !important;
          }

          .printContainer {
            height: 50%;
            width: 100%;

            box-sizing: border-box;
            padding: 40px;
          }

          .titleContainer {
            text-align: center;
          }

          .titleContainer h1 {
            font-size: 30px;
            font-weight: 400;
          }

          .footerContainer {
            display: flex;
            justify-content: space-around;
          }

          .footerContainer div {
            width: 20%;
          }

          .mainTable {
            width: 100%;
          }


          table {
            /* text-align: center; */
            border-collapse: collapse;
            width: 100%;

            margin: 5px 0 15px 0;
          }

          table td {
            box-sizing: border-box;
            padding: 10px;
            border: 1px solid #000000;

            height: 26px;

            font-size: 14px;
          }

          .tdLabel {
            text-align: center;
          }

          .signItems img {
            width: 80px;
          }
      `

  VXETable.print({
    style: htmlCss,
    // 自定义打印HTML
    content: htmlStr
  })
}
